/**
 * Model representing a master post
 */
export class PostosMaster {
  private _postoAtrelado: boolean;
  private _postoAtreladoAtual: boolean;

  constructor(
    public readonly id: number,
    public readonly codPosto: number,
    public readonly nomePosto: string,
    public readonly nomeFantasia: string,
    public readonly cnpj: string,
    public readonly descricaoRede: string,
    postoAtrelado: boolean = false
  ) {
    this._postoAtrelado = postoAtrelado;
    this._postoAtreladoAtual = postoAtrelado;
  }

  static fromJson(json: any): PostosMaster {
    const posto = new PostosMaster(
      json.id,
      json.codPosto,
      json.nomePosto || '',
      json.nomeFantasia || '',
      json.cnpj || '',
      json.descricaoRede || '',
      json.postoAtrelado ?? false
    );
    return posto;
  }

  get postoAtrelado(): boolean {
    return this._postoAtrelado;
  }

  set postoAtrelado(value: boolean) {
    this._postoAtrelado = value;
  }

  get PostoAtreladoAtual(): boolean {
    return this._postoAtreladoAtual;
  }

  set PostoAtreladoAtual(value: boolean) {
    this._postoAtreladoAtual = value;
  }

  get codPostoFormatado(): string {
    return this.codPosto.toString().padStart(5, '0');
  }

  hasChanges(): boolean {
    return this._postoAtrelado !== this._postoAtreladoAtual;
  }

  toJson(): any {
    return {
      id: this.id,
      codPosto: this.codPosto,
      nomePosto: this.nomePosto,
      nomeFantasia: this.nomeFantasia,
      cnpj: this.cnpj,
      descricaoRede: this.descricaoRede,
      postoAtrelado: this._postoAtrelado,
    };
  }
}

